/* /src/components/auth/logoutCallback.jsx */

import React from "react";
import { AuthConsumer } from "../../Providers/AuthProvider";


export const LogoutCallback = () => (
    <AuthConsumer>
        {({ signoutRedirectCallback }) => {
            signoutRedirectCallback();
            return <span></span>;
        }}
    </AuthConsumer>
);